import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box, TextField,
    Typography,
    Collapse,
    IconButton,
    TablePagination,
    Snackbar, Grid,
    Checkbox,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogActions, Select,
    Button,
    FormControl,
    DialogContent,
    Toolbar,
    AppBar,
    Slide,
    ListSubheader,
    InputLabel,
    Alert,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import { printSelectedRows } from './Print/ExpensesPrint';
import { styled, keyframes } from '@mui/system';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ScrollToTopButton from '../../Button/ScrollToTopButton';
import HomeIcon from '@mui/icons-material/Home';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import PaymentsIcon from '@mui/icons-material/Payments';
import MakePayment from '../../Popupdialogbox/ExpensesPayment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Notyf } from 'notyf';
import Expensespopup from '../../Popupdialogbox/Report-popups/Expenses';
import MoreVertIcon from '@mui/icons-material/MoreVert';


const notyf = new Notyf({
    position: { x: 'left', y: 'bottom' },
    duration: 3000,
});


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ExpensesTable = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [totalAmount, setTotalAmount] = useState(0);
    const [fetchedData, setFetchedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openRow, setOpenRow] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [alertOpen, setAlertOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [rows, setRows] = useState([{ category: '', amount: '' }]);
    const [fullname, setFullName] = useState('');
    const [paymenttype, setPaymenttype] = useState('');
    const [phone, setPhone] = useState('');
    const [type, setType] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const selectedRowsData = fetchedData.filter((expense) => selectedRows.includes(expense.id));
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const navigate = useNavigate();
    const [selectedExpensesPayment, setSelectedExpensesPayment] = useState(null);
    const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
    const [payments, setPayments] = useState([]);

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const handleSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}


    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/"); // Redirect on 401 error
                }
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        if (user.id) {
            fetchData();
        }
    }, [user.id]);

    const fetchData = () => {
        setLoading(true);

        axios.get('https://admin.bizstor.lk/public/api/get-expenses-category-data')
            .then(response => {
                if (user.id) {
                    const filteredExpenses = response.data.expenses.filter(expense =>
                        expense.usertoken.toLowerCase() === user.id.toString().toLowerCase() ||
                        expense.usertoken === "0"
                    );
                    setExpenses(filteredExpenses);
                } else {
                    setExpenses(response.data.expenses);
                }

                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
                setLoading(false);
            });


        axios.get('https://admin.bizstor.lk/public/api/get-customer-data')
            .then(response => {
                if (user.id) {
                    const filteredCustomers = response.data.customers.filter(customer =>
                        customer.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                    );
                    setCustomers(filteredCustomers);
                } else {
                    // If user.id is not present, set all customers
                    setCustomers(response.data.customers || []);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching customer data:', error);
                setLoading(false);
            });


        axios.get('https://admin.bizstor.lk/public/api/get-expense-data')
            .then(response => {
                if (user.id) {
                    const nisalOrders = response.data.filter(expense =>
                        expense.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                    );
                    setFetchedData(nisalOrders);
                    setFilteredData(nisalOrders);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching customer data:', error);
                setLoading(false);
            });


        axios.get('https://admin.bizstor.lk/public/api/suppliers')
            .then(response => {
                if (user.id) {
                    const filteredSuppliers = response.data.filter(supplier =>
                        supplier.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                    );
                    setSuppliers(filteredSuppliers);
                } else {
                    setSuppliers(response.data);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching customer data:', error);
                setLoading(false);
            });

    };



    const handleAddRow = () => {
        const newItem = {
            id: Date.now(),
            category: '',
            amount: 0,
        };

        setSelectedExpenses((prevState) => ({
            ...prevState,
            items: [...prevState.items, newItem],
        }));
    };


    useEffect(() => {
        fetchData();
    }, []);

    const handleRowClick = (index) => {
        setOpenRow(openRow === index ? null : index);
    };

    const handleRowSelect = (event, expenseId) => {
        const selectedIndex = selectedRows.indexOf(expenseId);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, expenseId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };

    const handleExpensesChange = (field, value) => {
        setSelectedExpenses((prevExpenses) => ({
            ...prevExpenses,
            [field]: value,
        }));
    };

    const isSelected = (expenseId) => selectedRows.indexOf(expenseId) !== -1;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const calculateTotalAmount = (items) => {
        const total = items.reduce((total, item) => total + Number(item.amount), 0);
        return total.toFixed(2);
    };



    {/**const handleDelete = async () => {
        setLoading(true);
        try {
            const promises = selectedRows.map(async (id) => {
                const response = await axios.delete(`https://admin.bizstor.lk/public/api/delete-expense-data/${id}`);
                return response.status === 200;
            });
            const results = await Promise.all(promises);

            if (results.every((result) => result)) {
                setFetchedData(fetchedData.filter(expense => !selectedRows.includes(expense.id)));
                //handleSnackbar('Selected expenses deleted successfully!', 'success');
                notyf.success('Selected expenses deleted successfully!');
                setSelectedRows([]);
                setDeleteConfirmationOpen(false);
                fetchData();
            } else {
                //setDeleteMessage('Failed to delete selected expenses.');
                notyf.error('Failed to delete selected expenses!');
            }
        } catch (error) {
            console.error('Error deleting data:', error);
            setDeleteMessage('Error deleting expenses.');
        } finally {
            setLoading(false);
        }
    };*/}

    const handleDelete = async () => {
        setLoading(true);
        try {
            const promises = selectedRows.map(async (id) => {
                try {
                    await axios.delete(`https://admin.bizstor.lk/public/api/delete-expense-data/${id}`);

                    await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-expenses-payment-data/${id}`).catch(error => {
                        if (error.response && error.response.status === 404) {
                            console.warn(`Payment data for expenses ${id} not found, skipping...`);
                        } else {
                            throw error;
                        }
                    });
                } catch (err) {
                    console.error(`Error deleting order ${id}:`, err);
                    throw err;
                }
            });

            await Promise.all(promises);

            setFetchedData(fetchedData.filter(expense => !selectedRows.includes(expense.id)));
            //handleSnackbar('Selected expenses deleted successfully!', 'success');
            notyf.success('Selected expenses deleted successfully!');
            setSelectedRows([]);
            setDeleteConfirmationOpen(false);
            fetchData();
        } catch (error) {
            //console.error('Error deleting data:', error);
            //handleSnackbar('Error deleting invoice(s)!', 'error');
            notyf.error('Error deleting Expenses!');

        } finally {
            setLoading(false);
        }
    };

    const clearDeleteMessage = () => {
        setDeleteMessage('');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDeleteConfirmation = () => {
        setDeleteConfirmationOpen(true);
    };

    const handleCloseDeleteConfirmation = () => {
        setDeleteConfirmationOpen(false);
    };

    const handleEditClick = (expense) => {
        setSelectedExpenses(expense);
        setEditDialogOpen(true);
    };

    const handleCloseEditDialog = () => {
        setEditDialogOpen(false);
        setSelectedExpenses(null);
    };

    const [selectedExpenses, setSelectedExpenses] = useState({
        fullname: '',
        phone: '',
        type: '',
        date: '',
        description: '',
        items: [],
    });

    const handleSave = async () => {
        setLoading(true);
        try {
            await axios.put(`https://admin.bizstor.lk/public/api/update-expense-data/${selectedExpenses.id}`, selectedExpenses);
            setAlertOpen(true);
            //handleSnackbar('Expenses updated successfully!', 'success');
            notyf.success('Expenses updated successfully!');
            fetchData(); // refresh the data after save
            handleCloseEditDialog();

        } catch (error) {
            //console.error('Error updating data:', error);
            notyf.error('Error updating data!');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteRow = (index) => {
        // Filter out the item to be deleted based on the index
        const updatedItems = selectedExpenses.items.filter((_, i) => i !== index);

        setSelectedExpenses((prevState) => ({
            ...prevState,
            items: updatedItems,
        }));
    };

    const handleExpensesItemChange = (index, field, value) => {
        const updatedItems = selectedExpenses.items.map((item, itemIndex) => {
            if (index === itemIndex) {
                return {
                    ...item,
                    [field]: value,
                };
            }
            return item;
        });

        setSelectedExpenses((prevExpenses) => ({
            ...prevExpenses,
            items: updatedItems,
        }));
    };

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        // Find if the selected value is a customer or supplier
        const selectedCustomer = customers.find(customer => customer.firstname === selectedValue);
        const selectedSupplier = suppliers.find(supplier => supplier.supplier_name === selectedValue);

        if (selectedCustomer) {
            setFullName(selectedCustomer.firstname);
            setPhone(selectedCustomer.phone || ''); // Set default phone if available
        } else if (selectedSupplier) {
            setFullName(selectedSupplier.supplier_name);
            setPhone(''); // Supplier may not have a phone number
        }

        setType(selectedValue);
    };

    const [selectedMonth, setSelectedMonth] = useState('');

    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        filterData(value, selectedMonth);
    };

    const handleMonthChange = (event) => {
        const value = event.target.value;
        setSelectedMonth(value);
        filterData(searchTerm, value);
    };

    const filterData = (term, month) => {
        const filtered = fetchedData.filter(expense => {
            const expenseDate = new Date(expense.date);
            const expenseMonth = expenseDate.toLocaleString('default', { month: 'long' }).toLowerCase();

            return (
                (term === '' ||
                    (expense.id && expense.id.toString().includes(term)) ||
                    (expense.fullname && expense.fullname.toLowerCase().includes(term)) ||
                    (expense.pay_id && expense.pay_id.toLowerCase().includes(term)) ||
                    (expense.date && expense.date.includes(term))) &&
                (month === '' || expenseMonth === month.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };


    const handleOpenPaymentDialog = (expense) => {
        setSelectedExpensesPayment(expense);
        setTotalAmount(calculateTotalAmount(expense.items));
        setPaymentDialogOpen(true);
    };



    const handleClosePaymentDialog = () => {
        setPaymentDialogOpen(false);
    };

    useEffect(() => {
        fetchPaymentData();
    }, []);

    const fetchPaymentData = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-expensespayment');
            if (user.id) {
                const Payment = response.data.filter(payment =>
                    payment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setPayments(Payment);
                setLoading(false);
            }
            setPayments(response.data);
        } catch (error) {
            console.error('Error fetching payment data:', error);
        } finally {
            setLoading(false);
        }
    };

    const calculateOrderTotalPayments = (orderId) => {
        // Calculate total payments made for this order
        return payments
            .filter(payment => payment.expenses_id === orderId)
            .reduce((total, payment) => total + Number(payment.amount), 0);
    };

    const getStatus = (totalAmount, totalPayments) => {
        const amount = totalAmount - totalPayments;
        return amount === 0 ? (
            <span style={{ display: 'flex', alignItems: 'center' }}>
                Completed
                <CheckCircleIcon sx={{ marginLeft: '8px', fontSize: '16px' }} />
            </span>
        ) : 'Pending';
    };

    const handleBackClick = () => {
        navigate("/allreport");
    };

    const handleDelete2 = async (id) => {
        setLoading(true);
        try {
            await axios.delete(`https://admin.bizstor.lk/public/api/delete-expense-data/${id}`);

            await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-expenses-payment-data/${id}`).catch(error => {
                if (error.response && error.response.status === 404) {
                    console.warn(`Payment data for expenses ${id} not found, skipping...`);
                } else {
                    throw error;
                }
            });
            notyf.success('expenses deleted successfully!');
            fetchData();

        } catch (error) {
            notyf.error('Error deleting Expenses!');

        } finally {
            setLoading(false);
        }
    }

    const [anchorE2, setAnchorE2] = useState(null);
    const [openMenuRowIndex, setOpenMenuRowIndex] = useState(null);

    // Updated handlers
    const handleMenuOpen2 = (e, rowIndex) => {
        e.stopPropagation();
        setAnchorE2(e.currentTarget);
        setOpenMenuRowIndex(rowIndex);
    };

    const handleMenuClose2 = () => {
        setAnchorE2(null);
        setOpenMenuRowIndex(null);
    };


    return (
        <Box
            sx={{ mt: 10 }}
        >
            <Dialog open={paymentDialogOpen} onClose={handleClosePaymentDialog}>
                <DialogTitle>Make Payment</DialogTitle>
                <DialogContent>
                    <MakePayment expenses={selectedExpensesPayment} totalAmount={totalAmount} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePaymentDialog} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 }, // Adjust margins for responsiveness
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font size
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 'bold',
                            color: '',
                        }}
                    >
                        Expenses
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' }, // Hidden on xs
                            ml: 1,
                            fontSize: '14px',
                            color: '',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Report - Expenses
                    </Typography>
                </Box>
            </AnimatedTypography>

            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 3,
                    mt: 3,
                    fontSize: '1rem',
                    color: 'secondary.main',
                    letterSpacing: '0.01em'
                }}
            >
                Dashboard / Report / Expenses
            </AnimatedTypography>*/}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                }}
            >
                <Typography variant="h4">

                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' }, // Responsive direction
                        justifyContent: 'space-between', // Space between left and right groups
                        alignItems: 'center', // Align items vertically
                        p: 2, // Padding inside the box
                        gap: 2, // Space between sections

                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'left',
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                            },

                        }}
                    >
                        <Box sx={{ color: '#1e293b', }}><h2>Expenses</h2></Box>
                        <Box
                            component="div"
                            sx={{
                                mb: { sm: 2, xs: 'none' },
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: 'primary.main',
                                width: 'fit-content',
                                '&:hover': {
                                    color: 'primary.main',
                                }
                            }}
                            onClick={handleBackClick}
                        >
                            <ArrowBackIcon fontSize="small" />
                            <Typography
                                variant="body2"
                                sx={{
                                    ml: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Back to Report
                            </Typography>
                        </Box>
                    </Box>

                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: isSearchOpen ? 1 : 0, height: isSearchOpen ? 'auto' : 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: 'hidden', }}
                    >
                        <Box
                            sx={{
                                display: { sm: 'none', xs: 'flex' },
                                flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on small screens
                                gap: 1, // Space between the TextFields
                                width: '80%', // Ensure it takes full width on smaller screens
                                alignItems: 'center', // Align items vertically
                                '@media (max-width: 600px)': {
                                    margin: 'auto',
                                },
                            }}
                        >
                            <TextField
                                variant="outlined"
                                margin="normal"
                                onChange={handleSearchChange}
                                value={searchTerm}
                                size="small"
                                placeholder="Search…"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    width: '250px',
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    },
                                }}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                onChange={handleSearchChange}
                                value={searchTerm}
                                size="small"
                                type="date"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    width: '250px',
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    },
                                }}
                            />

                            <Select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                displayEmpty
                                size="small"
                                sx={{
                                    width: '250px',
                                    height: '40px',
                                    mt: 1,
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        bgcolor: 'rgba(240, 240, 240, 0.17)',
                                    },
                                }}
                            >
                                <MenuItem value="">
                                    <em>All Months</em>
                                </MenuItem>
                                <MenuItem value="January">January</MenuItem>
                                <MenuItem value="February">February</MenuItem>
                                <MenuItem value="March">March</MenuItem>
                                <MenuItem value="April">April</MenuItem>
                                <MenuItem value="May">May</MenuItem>
                                <MenuItem value="June">June</MenuItem>
                                <MenuItem value="July">July</MenuItem>
                                <MenuItem value="August">August</MenuItem>
                                <MenuItem value="September">September</MenuItem>
                                <MenuItem value="October">October</MenuItem>
                                <MenuItem value="November">November</MenuItem>
                                <MenuItem value="December">December</MenuItem>
                            </Select>
                        </Box>

                    </motion.div>
                    {/* Left side: Search fields */}
                    <Box
                        sx={{
                            display: { sm: 'none', xs: 'none' },
                            flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on small screens
                            gap: 1, // Space between the TextFields
                            width: '80%', // Ensure it takes full width on smaller screens
                            alignItems: 'center', // Align items vertically
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                            },
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            placeholder="Search…"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                width: '250px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            type="date"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                width: '250px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        />

                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            displayEmpty
                            size="small"
                            sx={{
                                width: '250px',
                                height: '40px',
                                mt: 1,
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>All Months</em>
                            </MenuItem>
                            <MenuItem value="January">January</MenuItem>
                            <MenuItem value="February">February</MenuItem>
                            <MenuItem value="March">March</MenuItem>
                            <MenuItem value="April">April</MenuItem>
                            <MenuItem value="May">May</MenuItem>
                            <MenuItem value="June">June</MenuItem>
                            <MenuItem value="July">July</MenuItem>
                            <MenuItem value="August">August</MenuItem>
                            <MenuItem value="September">September</MenuItem>
                            <MenuItem value="October">October</MenuItem>
                            <MenuItem value="November">November</MenuItem>
                            <MenuItem value="December">December</MenuItem>
                        </Select>
                    </Box>

                    {/* Right side: Icons */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1, // Space between the icons
                        }}
                    >
                        <IconButton
                            onClick={toggleSearch}
                            sx={{
                                display: { sm: 'none', md: 'none', xs: 'flex' }
                            }}
                        >
                            <SearchIcon />
                        </IconButton>

                        <IconButton
                            aria-label="print"
                            onClick={() => printSelectedRows(selectedRowsData)}
                            disabled={selectedRows.length === 0}
                        >
                            <PrintIcon />
                        </IconButton>
                        <IconButton
                            aria-label="delete"
                            onClick={handleMenuOpen}
                            disabled={selectedRows.length === 0}
                        >
                            <DeleteIcon
                                sx={{
                                    '&:hover': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={handleOpenDeleteConfirmation}>
                                Delete Selected Expenses
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>

                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={handleCloseDeleteConfirmation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete selected expenses?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={handleCloseDeleteConfirmation} color="primary">
                            No
                        </Button>
                        <Button onClick={handleDelete}
                            sx={{
                                backgroundColor: 'red',
                                color: 'white',
                                '&:hover': {
                                    color: 'white',
                                    backgroundColor: 'red',
                                },
                            }}
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                <Box
                    sx={{
                        display: { sm: 'flex', xs: 'none' },
                        flexDirection: 'row',
                        width: '100%',
                        height: '50px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            placeholder="Search…"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mt: 1,
                                width: '245px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            type="date"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mt: 1,
                                width: '245px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            displayEmpty
                            size="small"
                            sx={{
                                width: '245px',
                                height: '40px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: 'rgba(240, 240, 240, 0.17)',
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>All Months</em>
                            </MenuItem>
                            <MenuItem value="January">January</MenuItem>
                            <MenuItem value="February">February</MenuItem>
                            <MenuItem value="March">March</MenuItem>
                            <MenuItem value="April">April</MenuItem>
                            <MenuItem value="May">May</MenuItem>
                            <MenuItem value="June">June</MenuItem>
                            <MenuItem value="July">July</MenuItem>
                            <MenuItem value="August">August</MenuItem>
                            <MenuItem value="September">September</MenuItem>
                            <MenuItem value="October">October</MenuItem>
                            <MenuItem value="November">November</MenuItem>
                            <MenuItem value="December">December</MenuItem>
                        </Select>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end',
                            width: '20%',
                        }}
                    >
                        <Expensespopup />
                    </Box>
                </Box>

                <TableContainer style={{ marginTop: '20px', }}>
                    <Table>
                        <TableHead>
                            <TableRow
                                sx={{
                                    '& td, & th': { padding: '8px 12px', bgcolor: '#F7FAFC' },
                                }}
                            >
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        indeterminate={selectedRows.length > 0 && selectedRows.length < fetchedData.length}
                                        checked={selectedRows.length === fetchedData.length}
                                        onChange={() => {
                                            if (selectedRows.length === fetchedData.length) {
                                                setSelectedRows([]);
                                            } else {
                                                setSelectedRows(fetchedData.map((expense) => expense.id));
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell><b>Date</b></TableCell>
                                <TableCell><b>ID</b></TableCell>
                                <TableCell><b>Name</b></TableCell>
                                <TableCell><b>Total</b></TableCell>
                                <TableCell><b>Payment Type</b></TableCell>
                                <TableCell><b>Status</b></TableCell>
                                <TableCell><b></b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={8}>
                                        {loading && (
                                            <Box sx={{
                                                position: 'fixed',
                                                top: 0,
                                                left: 0,
                                                width: '100vw',
                                                height: '100vh',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                bgcolor: 'white',
                                                zIndex: 9999
                                            }}>
                                                <l-trio
                                                    size="50"
                                                    speed="1.3"
                                                    color="red"
                                                ></l-trio>
                                            </Box>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredData.sort((a, b) => new Date(b.date) - new Date(a.date))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((expense, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow
                                                hover
                                                onClick={() => handleRowClick(index)}
                                                role="checkbox"
                                                aria-checked={isSelected(expense.id)}
                                                tabIndex={-1}
                                                selected={isSelected(expense.id)}
                                                sx={{
                                                    '& td, & th': { padding: '8px 12px' },
                                                    backgroundColor: openRow === index ? '#f0f0f0' : 'inherit',
                                                }}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isSelected(expense.id)}
                                                        onChange={(event) => handleRowSelect(event, expense.id)}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{ fontSize: '14px' }}>
                                                        {expense.date}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{ fontSize: '14px' }}>
                                                        {expense.id}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{ fontSize: '14px' }}>
                                                        {expense.fullname}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{ fontSize: '14px' }}>
                                                        LKR.{calculateTotalAmount(expense.items)}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{ fontSize: '14px' }}>
                                                        {expense.paymenttype}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    {expense.paymenttype !== 'Paid' ? (
                                                        <Typography sx={{ fontSize: '14px', color: getStatus(calculateTotalAmount(expense.items), calculateOrderTotalPayments(expense.id)) === 'Pending' ? 'orange' : 'green' }}>
                                                            {getStatus(calculateTotalAmount(expense.items), calculateOrderTotalPayments(expense.id))}
                                                        </Typography>
                                                    ) : (
                                                        <Typography sx={{ fontSize: '14px', color: 'green', display: 'flex', alignItems: 'center' }}>
                                                            Completed
                                                            <CheckCircleIcon sx={{ marginLeft: '8px', fontSize: '16px' }} />
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <Box alignItems="center">
                                                        <div onClick={(e) => e.stopPropagation()}>
                                                            <IconButton onClick={(e) => handleMenuOpen2(e, index)}>
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                            <Menu
                                                                anchorEl={anchorE2}
                                                                open={openMenuRowIndex === index}
                                                                onClose={handleMenuClose2}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <MenuItem onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleEditClick(expense);
                                                                    handleMenuClose2();
                                                                }}
                                                                    sx={{
                                                                        fontSize: '15px',
                                                                        minHeight: 'auto',
                                                                        py: 0.5
                                                                    }}
                                                                >
                                                                    <EditNoteIcon sx={{
                                                                        mr: 1,
                                                                        fontSize: '19px'
                                                                    }} />
                                                                    Edit
                                                                </MenuItem>

                                                                {expense.paymenttype !== 'Paid' && (
                                                                    <MenuItem onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleOpenPaymentDialog(expense);
                                                                        handleMenuClose2();
                                                                    }}
                                                                        sx={{
                                                                            fontSize: '15px',
                                                                            minHeight: 'auto',
                                                                            py: 0.5
                                                                        }}
                                                                    >
                                                                        <PaymentsIcon sx={{
                                                                            mr: 1,
                                                                            fontSize: '19px'
                                                                        }} />
                                                                        Make Payment
                                                                    </MenuItem>
                                                                )}

                                                                <MenuItem onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDelete2(expense.id);
                                                                    handleMenuClose2();
                                                                }}
                                                                    sx={{
                                                                        fontSize: '15px',
                                                                        minHeight: 'auto',
                                                                        py: 0.5
                                                                    }}
                                                                >
                                                                    <DeleteIcon sx={{
                                                                        mr: 1,
                                                                        fontSize: '19px'
                                                                    }} />
                                                                    Delete
                                                                </MenuItem>
                                                                <MenuItem onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    printSelectedRows([expense]);
                                                                    handleMenuClose2();
                                                                }}
                                                                    sx={{
                                                                        fontSize: '15px',
                                                                        minHeight: 'auto',
                                                                        py: 0.5
                                                                    }}
                                                                >
                                                                    <PrintIcon sx={{
                                                                        mr: 1,
                                                                        fontSize: '19px'
                                                                    }} />
                                                                    Print
                                                                </MenuItem>
                                                            </Menu>
                                                        </div>

                                                    </Box>
                                                </TableCell>
                                                {/**<TableCell>
                                                    <IconButton onClick={() => handleEditClick(expense)}>
                                                        <EditNoteIcon
                                                            sx={{
                                                                '&:hover': {
                                                                    color: 'black',
                                                                },
                                                            }}
                                                        />
                                                    </IconButton>
                                                    {expense.paymenttype !== 'Paid' && (
                                                        <IconButton onClick={() => handleOpenPaymentDialog(expense)}>
                                                            <PaymentsIcon
                                                                sx={{
                                                                    '&:hover': {
                                                                        color: 'black',
                                                                    },
                                                                }}
                                                            />
                                                        </IconButton>
                                                    )}
                                                    <IconButton onClick={() => handleDelete2(expense.id)} aria-label="delete"
                                                        sx={{ '&:hover': { color: 'red' } }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>*/}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                    <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                                                        <Box margin={1} padding={2} bgcolor="#f9f9f9" borderRadius={4} >
                                                            <Typography variant="subtitle1" gutterBottom component="div" color="primary">
                                                                Expenses Details #{expense.pay_id}
                                                            </Typography>
                                                            <Table size="small" aria-label="details">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell><b>Category</b></TableCell>
                                                                        <TableCell><b>Amount</b></TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {expense.items.map((item, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell sx={{ color: '#636363', fontSize: '14px' }}>{item.category}</TableCell>
                                                                            <TableCell sx={{ color: '#636363', fontSize: '14px' }}>LKR.{(item.amount)}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell colSpan={1} align="right">
                                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Total Amount</Typography>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>LKR.{calculateTotalAmount(expense.items)}</Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    {expense.paymenttype !== 'Paid' && (
                                                                        <TableRow>
                                                                            <TableCell colSpan={1} align="right">
                                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Due</Typography>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                                    LKR.{(calculateTotalAmount(expense.items) - calculateOrderTotalPayments(expense.id)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </Typography>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )}
                                                                </TableBody>
                                                            </Table>
                                                            <Typography sx={{ fontSize: '14px' }} gutterBottom component="div" color="textSecondary" mt={2}>
                                                                Description
                                                            </Typography>
                                                            <Typography variant="body2" gutterBottom component="div">
                                                                {expense.description}
                                                            </Typography>
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>


                <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    mt={2}
                >
                    <TablePagination
                        rowsPerPageOptions={[100, 200, 300]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage=""
                    />
                </Box>


                <Dialog
                    open={editDialogOpen}
                    onClose={handleCloseEditDialog}
                    TransitionComponent={Transition}
                    fullWidth
                    maxWidth="xl"
                >
                    <AppBar sx={{ position: 'relative', bgcolor: '#FAFAFA', boxShadow: 'none',borderBottom: '1px solid #e0e0e0' }}>
                        <Toolbar>           
                            <Typography sx={{ ml: 2, flex: 1, color: 'black', fontWeight: 'bold' }} variant="h6" component="div">
                                Edit Expenses
                            </Typography>
                            <IconButton edge="end" color="inherit" onClick={handleCloseEditDialog} aria-label="close">
                                <CloseIcon sx={{ color: 'red' }} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        {selectedExpenses && (
                            <form>
                                <Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl variant="outlined" fullWidth size="small">
                                            <InputLabel >Select Person</InputLabel>
                                            <Select
                                                value={type}
                                                onChange={handleSelectChange}
                                                label="Select Person"
                                                fullWidth
                                            >
                                                <ListSubheader>Customers</ListSubheader>
                                                {customers.length > 0 && customers.map(customer => (
                                                    <MenuItem key={customer.id} value={customer.firstname}>
                                                        {customer.firstname}
                                                    </MenuItem>
                                                ))}
                                                <ListSubheader>Suppliers</ListSubheader>
                                                {suppliers.map(supplier => (
                                                    <MenuItem key={supplier.id} value={supplier.supplier_name}>
                                                        {supplier.supplier_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            margin="normal"
                                            label="Full Name"
                                            fullWidth
                                            size="small"
                                            value={fullname || selectedExpenses.fullname} // Use state variable for value
                                            onChange={(e) => handleExpensesChange('fullname', e.target.value)} // Preserve existing onChange handler
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} mt={1}>
                                        <FormControl variant="outlined" fullWidth size="small">
                                            <InputLabel>Payment Type</InputLabel>
                                            <Select
                                                value={paymenttype || selectedExpenses.paymenttype}
                                                onChange={(e) => handleExpensesChange('paymenttype', e.target.value)}
                                                label="Payment Type"
                                                fullWidth
                                            >
                                                <MenuItem value="Paid">Paid</MenuItem>
                                                <MenuItem value="Credit">Credit</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            margin="normal"
                                            label="Date"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={selectedExpenses.date}
                                            onChange={(e) => handleExpensesChange('date', e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleAddRow}
                                        style={{ backgroundColor: 'black', color: 'white' }}
                                    >
                                        <PlaylistAddIcon />
                                    </Button>
                                </Box>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Category</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedExpenses.items && selectedExpenses.items.map((item, index) => (
                                            <TableRow key={item.id} sx={{ height: '40px' }}>
                                                <TableCell sx={{ padding: '8px' }}>
                                                    <FormControl variant="outlined" fullWidth size="small">
                                                        <Select
                                                            value={item.category}
                                                            onChange={(e) => handleExpensesItemChange(index, 'category', e.target.value)}
                                                        >
                                                            {expenses.map((expense) =>
                                                                expense.subexpenses && expense.subexpenses.length > 0 ? (
                                                                    expense.subexpenses.map((subexpense) => {
                                                                        const label = `${expense.expenses} - ${subexpense.subexpense}`;
                                                                        return (
                                                                            <MenuItem key={`${expense.id}-${subexpense.id}`} value={label}>
                                                                                {label}
                                                                            </MenuItem>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <MenuItem key={expense.id} value={expense.expenses}>
                                                                        {expense.expenses}
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell sx={{ padding: '8px' }}> {/* Adjust the padding as needed */}
                                                    <TextField
                                                        value={item.amount}
                                                        onChange={(e) => handleExpensesItemChange(index, 'amount', e.target.value)}
                                                        type="number"
                                                        size="small"
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ padding: '8px' }}> {/* Adjust the padding as needed */}
                                                    <IconButton
                                                        onClick={() => handleDeleteRow(index)}
                                                        aria-label="delete"
                                                        color="inherit"
                                                        size="small"
                                                    >
                                                        <DeleteIcon
                                                            sx={{
                                                                '&:hover': {
                                                                    color: 'red',
                                                                },
                                                                fontSize: '20px', // Adjust the icon size as needed
                                                            }}
                                                        />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>

                                        ))}
                                        <Grid item xs={6}>
                                            <TextField
                                                margin="normal"
                                                label="Description"
                                                fullWidth
                                                multiline
                                                rows={4} // Adjust this number to set the height
                                                size="small"
                                                value={selectedExpenses.description}
                                                onChange={(e) => handleExpensesChange('description', e.target.value)}
                                            />
                                        </Grid>

                                    </TableBody>
                                </Table>
                            </form>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={handleSave} color="primary">
                            Save Changes
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{
                            width: '100%',

                        }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
            <ScrollToTopButton />
        </Box>
    );
};

export default ExpensesTable;
